import { useMemo } from 'react'
import { useUsers } from './useUsers'

/** Display names by user id, for rendering who did something. Empty while the directory loads. */
export function useUserNames(): ReadonlyMap<string, string> {
	const { data: users = [] } = useUsers()
	return useMemo(() => new Map(users.map((u) => [u.userId, u.displayName])), [users])
}
